var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-container',[_c('el-container',[_c('el-main',{staticStyle:{"background-color":"#eef1f6","margin":"0","padding":"0","border":"none"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }